<template>
  <v-container fluid pl-4>
    <v-layout row wrap pl-2 pr-4>
      <v-flex xs12>
        <v-form ref="form">
          <v-layout row wrap>
            <v-flex md12>
              <v-text-field
                color="black"
                label="Nombre"
                v-model="form.name"
                :error-messages="errors.collect('name')"
                v-validate="'required|max:100'"
                data-vv-name="name"
                data-vv-as="nombre"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md6 pr-5>
              <v-text-field
                color="black"
                label="Email"
                v-model="form.email"
                @keypress="vaina($event)"
                :error-messages="errors.collect('email')"
                v-validate="'required|max:100|cktia'"
                data-vv-name="email"
                data-vv-as="email"
              ></v-text-field>
            </v-flex>
            <v-flex md6>
              <v-select
                :items="domains"
                v-model="form.domain"
                label="Dominio"
                item-text="domain"
                item-value="domain"
                :error-messages="errors.collect('email')"
                v-validate="'required|max:100'"
                color="black"
                data-vv-name="domain"
                data-vv-as="dominio"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                color="black"
                label="Responde a"
                v-model="form.forwarding"
                :error-messages="errors.collect('forwarding')"
                v-validate="'required|email|max:100'"
                data-vv-name="forwarding"
                data-vv-as="responde a"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
        <v-layout row wrap>
          <v-flex xs8 text-xs-right>
            <v-btn color="black" flat @click="close">CANCELAR</v-btn>
          </v-flex>
          <v-flex xs4 text-xs-right>
            <v-btn class="k-orange-linear-text" flat @click="save">GUARDAR</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import sidebarFormMixin from '@/mixins/sidebarForm';
import { Validator } from 'vee-validate';

export default {
  mixins: [
    sidebarFormMixin,
  ],
  props: {
    url: String,
    edit: Boolean,
  },
  data() {
    return {
      form: {
        email: '',
        forwarding: '',
        name: '',
      },
      domains: [],
    };
  },
  created() {
    this.axios.get('domains?status=Activo&paginate=0').then((response) => {
      this.domains = response.data;
    }).catch(() => { });
    /* eslint-disable */
    const validator = {
      getMessage(field, args) {
        // will be added to default locale messages.
        // Returns a message.
      },
      validate(value, args) {
        // Returns a Boolean or a Promise that resolves to a boolean.
      },
    };

    Validator.extend('cktia', {
      getMessage: (field) => `No puede cambiar el dominio @cktia.com al ${field}.`,
      validate: (value) => value.includes('@') ? false : true,
    });
  },
  methods: {
    vaina(event) {
      if (event.key === '@') {
        event.preventDefault();
      }
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/global/sidebar_forms/CompanyEmail.vue